import { followLink } from "@/lib/openapi/helpers";
import { Artefact } from "@/lib/artefacts";
import { type Domain } from "@/composables/domain-manager";
import { type Product } from "@/composables/product-manager";
import { type Process } from "@/composables/process-manager";
import { type Task } from "@/stores/task-store";
import { Gateway } from "@/stores/gateway-store";
import { Event } from "@/stores/event-store";
import { Flow } from "@/stores/flow-store";

export async function getDescriptionArtefact(
    apiEntity: Domain | Product | Process | Task | Gateway | Event | Flow,
    name: string,
    signal?: AbortSignal,
    query?: URLSearchParams
): Promise<Artefact<"text/markdown">> {
    if (apiEntity.description) {
        let mimetype = apiEntity.description.mimetype;
        // Upgrade plain text to markdown.
        if (mimetype === "text/plain") {
            mimetype = "text/markdown";
        }
        if (mimetype !== "text/markdown") {
            throw Error(
                `Can only handle markdown descriptions! Not ${mimetype}`
            );
        }

        const { data } = await followLink<File>(
            apiEntity.description,
            "get",
            undefined,
            signal,
            query
        );

        // Assuming data might already be the blob or response data
        const blob = data instanceof Blob ? data : new Blob([data || ""]);

        return new Artefact({
            name,
            identity: apiEntity.description.identity,
            blob: blob,
            mimetype: mimetype,
            content: await blob.text(),
        });
    } else {
        return Artefact.createEmptyArtefact({
            mimetype: "text/markdown",
            identity: apiEntity.identity + "_description",
        });
    }
}
